/** Must match the `standard.type` value stored in the DB for packaging catalogue rows (`"PACKAGING"`). */
export const PACKAGING_STANDARD_TYPE = 'PACKAGING' as const

export function isPackagingStandardType(
  type: string | null | undefined
): boolean {
  return type === PACKAGING_STANDARD_TYPE
}

export function isMachineryListUserStandard(
  type: string | null | undefined
): boolean {
  return !isPackagingStandardType(type)
}

export function isMachineryListGlobalStandard(
  type: string | null | undefined
): boolean {
  return !isPackagingStandardType(type)
}
